import { CreateEventDocument } from '@/generated/graphql';
import { useMyUser } from '@/user/composables/useMyUser';
import { useMutation } from '@vue/apollo-composable';
import { Ref, toValue } from 'vue';
import { EventCreateSchemaType } from '../forms/schemas';

export function useEventCreate(seriesId: Ref<string>) {
    const createEvent = useMutation(CreateEventDocument);
    const { currentUser } = useMyUser();

    async function create(data: Ref<EventCreateSchemaType>) {
        const saveData = { ...toValue(data), status: toValue(data).status?.id ?? null };
        const res = await createEvent.mutate({
            seriesId: toValue(seriesId),
            ...saveData,
            createdById: currentUser.value.id,
            createdByName: currentUser.value.name,
        });
        const { id } = res?.data?.createEvent?.event ?? {};
        if (id) {
            return { id, errors: [] };
        }
        return { id: undefined, errors: res?.errors };
    }

    return {
        create,
    };
}
